function createBtn(root, element, src) {
  const ParentStyle = root.getBoundingClientRect()
  const style = element.getBoundingClientRect()
  const styles = window.getComputedStyle(root, null)
  if (['absolute', 'relative'].indexOf(styles['position']) === -1) {
    root.style.position = 'relative'
  }
  let dom = document.createElement('span')
  dom.className = 'watchImgBtn'
  dom.innerHTML = '查看原图'
  dom.style.position = 'absolute'
  dom.style.width = '60px'
  dom.style.height = '24px'
  dom.style.lineHeight = '24px'
  dom.style.fontSize = '12px'
  dom.style.background = 'rgba(0, 0, 0, 0.5)'
  dom.style.color = 'white'
  dom.style.textAlign = 'center'
  dom.style.borderTopLeftRadius = '4px'
  dom.style.borderBottomRightRadius = '4px'
  dom.style.cursor = 'pointer'
  dom.style.top = style.bottom - ParentStyle.top - 24 + 'px'
  dom.style.left = style.right - ParentStyle.left - 60 + 'px'
  dom.onclick = function() {
    createYuanTu(src)
  }
  return dom
}
function createYuanTu(src) {
  let dom = document.createElement('div')
  dom.className = 'watchCover'
  let warp = document.createElement('div')
  warp.className = 'watchImgCenter'
  let img = document.createElement('img')
  img.src = src
  img.style.maxHeight = '100%'
  img.style.maxWidth = '100%'
  warp.appendChild(img)
  dom.appendChild(warp)
  document.body.appendChild(dom)
  dom.onclick = function(e) {
    if (e.target.src) return
    document.body.removeChild(dom)
    return false
  }
}

export default {
  methods: {
    addWatchBtn(root) {
      const imgNodeList = root.querySelectorAll('img')
      imgNodeList.forEach(element => {
        element.onload = () => {
          root.appendChild(createBtn(root, element, element.src))
        }
      })
    },
    closeYuanTu() {
      const dom = document.querySelector('.watchCover')
      dom && dom.click()
    },
    removeBtn(root) {
      const imgNodeList = root.querySelectorAll('.watchImgBtn')
      imgNodeList.forEach(element => {
        root.removeChild(element)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/ui/src/mixins/watchImg.js